import React from 'react';
import { Navigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import AdminDashboard from './AdminDashboard';

const Dashboard = () => {
  const { currentUser } = useApp();
  if (currentUser.role === 'admin') return <AdminDashboard />;
  // Teachers and students land straight on Attendance — it's the page
  // they need on every visit, and a separate "your batches" dashboard
  // was just an extra click in front of it.
  return <Navigate to="/attendance" replace />;
};

export default Dashboard;
